import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, FormControlLabel, Paper } from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TextField,
  Grid,
  Button,
  Checkbox,
} from '../../../../../components/common';
import texts from '../../../../../assets/texts';
import AccordionFormContext from '../../../../../store/accordion-form-context';
import { loan } from '../../../../../utils';
import FarmContext from '../../../../../store/farm-context';

export default function FinancialSector() {
  const history = useHistory();
  const accordionCTX = useContext(AccordionFormContext);
  const farmCTX = useContext(FarmContext);
  const [fourthStageButtonDisabled, setFourthStageButtonDisabled] =
    useState(true);

  useEffect(() => {
    if (
      !(
        accordionCTX.form.loanAmount.length < 1 ||
        accordionCTX.form.loanType.length < 1 ||
        accordionCTX.form.isTakingDirectPayments.length < 1 ||
        parseInt(accordionCTX.form.loanAmount) < 999 ||
        accordionCTX.form.email.length < 1 ||
        accordionCTX.form.phoneNumber.length < 1
      ) &&
      Number.isInteger(parseInt(accordionCTX.form.loanAmount)) &&
      accordionCTX.form.dataProcessingPermission &&
      accordionCTX.form.agrowePermission &&
      accordionCTX.form.bankPermission &&
      accordionCTX.form.bigAgreement &&
      !(
        accordionCTX.form.idDocNumber.length < 1 &&
        accordionCTX.form.name.length < 1 &&
        accordionCTX.form.surname.length < 1 &&
        accordionCTX.form.pesel.length < 1 &&
        accordionCTX.form.directPaymentYear.length < 1 &&
        accordionCTX.form.directPaymentIncome.length < 1 &&
        accordionCTX.form.directPaymentIdentification.length < 1
      )
    ) {
      if (accordionCTX.form.hasCompany) {
        if (
          !(
            accordionCTX.form.companyName.length < 1 ||
            accordionCTX.form.nip.length < 1 ||
            accordionCTX.form.regon.length < 1
          )
        ) {
          if (accordionCTX.form.bigAgreementNIP) {
            setFourthStageButtonDisabled(false);
          } else {
            setFourthStageButtonDisabled(true);
          }
        } else {
          setFourthStageButtonDisabled(true);
        }
      } else {
        setFourthStageButtonDisabled(false);
      }
    } else {
      setFourthStageButtonDisabled(true);
    }
  }, [accordionCTX.form]);

  const handleCheckboxChange = (event) => {
    switch (event.target.name) {
      case 'bigAgreement':
        accordionCTX.changeFormValue('bigAgreement', event.target.checked);
        break;

      case 'bigAgreementNIP':
        accordionCTX.changeFormValue('bigAgreementNIP', event.target.checked);
        break;
      default:
    }
  };

  const handleHasCompany = (event) =>
    accordionCTX.changeFormValue('hasCompany', event.target.checked);
  const handleIdNumberChange = (event) =>
    accordionCTX.changeFormValue('idDocNumber', event.target.value);
  const handleCompanyNameChange = (event) =>
    accordionCTX.changeFormValue('companyName', event.target.value);
  const handleNipChange = (event) =>
    accordionCTX.changeFormValue('nip', event.target.value);
  const handleRegonChange = (event) =>
    accordionCTX.changeFormValue('regon', event.target.value);

  const submitFullForm = async () => {
    accordionCTX.changeStatus('LOADING', true);
    const body = {
      directPaymentId: accordionCTX.form.directPaymentId,
      farmId: farmCTX.farmID,
      name: accordionCTX.form.name,
      surname: accordionCTX.form.surname,
      pesel: accordionCTX.form.pesel,
      idDocNumber: accordionCTX.form.idDocNumber,
      companyName: accordionCTX.form.companyName,
      nip: accordionCTX.form.nip,
      regon: accordionCTX.form.regon,
      loanAmount: accordionCTX.form.loanAmount,
      loanType: accordionCTX.form.loanType,
      loanLength: accordionCTX.form.loanLength,
      phoneNumber: accordionCTX.form.phoneNumber,
      email: accordionCTX.form.email,
      directPaymentYear: accordionCTX.form.directPaymentYear,
      directPaymentIncome: accordionCTX.form.directPaymentIncome,
      directPaymentIdentification:
        accordionCTX.form.directPaymentIdentification,
      bigAgreement: accordionCTX.form.bigAgreement,
      bigAgreementNIP: accordionCTX.form.bigAgreementNIP,
      dataProcessingPermission: accordionCTX.form.dataProcessingPermission,
      bankPermission: accordionCTX.form.bankPermission,
      agrowePermission: accordionCTX.form.agrowePermission,
      additionalIncomeRequestList:
        accordionCTX.form.additionalIncomeRequestList,
      animalProductionRequestList:
        accordionCTX.form.animalProductionRequestList,
      financialLiabilityRequestList:
        accordionCTX.form.financialLiabilityRequestList,
    };
    await loan
      .patchLoanApplication(accordionCTX.form.loanApplicationID, body)
      .then((result) => {
        if (result.data != null) {
          let text;
          if (result.data.responseStatus === 'unable to check at big') {
            text = texts.accordionFormSubmitUnableToCheck;
          } else if (result.data.responseStatus === 'loan too high') {
            text = texts.accordionFormSubmitLoanTooHigh;
          } else if (result.data.responseStatus === 'big access not provided') {
            text = texts.accordionFormSubmitNoBIGAccess;
          } else if (result.data.responseStatus === 'customer not solvent') {
            text = texts.accordionFormSubmitCustomerNotSolvent;
          } else if (result.data.responseStatus === 'error') {
            text = texts.accordionFormSubmitError;
          } else if (result.data.responseStatus === 'success') {
            text = texts.accordionFormSubmitSuccess;
          } else if (
            result.data.responseStatus === 'user does not have big permissions'
          ) {
            text = texts.accordionFormSubmitUserNoPermissions;
          }
          accordionCTX.changeStatus('TEXT', text);
          if (result.data.applicationId != null) {
            accordionCTX.changeFormValue(
              'loanApplicationID',
              result.data.applicationId
            );
            getLoanAdditionalIncomes(result.data.applicationId).then(() => {
              //TO CHANGE BACK, UNLOCK AFTER GETTING ADDITIONAL INCOMES
            });
          }
          accordionCTX.changeNavigation('UNLOCK', 'panel8');
        }
        accordionCTX.changeStatus('LOADING', false);
      });
  };

  const getLoanAdditionalIncomes = async (id) => {
    await loan
      .incomes(id)
      .then((result) => {
        if (result.status === 403) {
          history.push('/login');
        }
        if (result.data != null) {
          accordionCTX.changeFormValue(
            'additionalProductionResponses',
            result.data.additionalIncomeResponseList
          );
          accordionCTX.changeFormValue(
            'animalProductionResponses',
            result.data.animalProductionResponseList
          );
          accordionCTX.changeFormValue(
            'financialLiabilityResponses',
            result.data.financialLiabilityResponseList
          );
        }
      })
      .catch(() => {});
  };

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel7'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel7')}
    >
      <AccordionSummary aria-controls="panel7d-content" id="panel7d-header">
        <h1>7. Twoja współpraca z sektorem finansowym</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid
            infoCard
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            component={Paper}
          >
            <Typography variant="h4">
              W celu potwierdzenia Twojej współpracy z sektorem finansowym
              potrzebujemy jeszcze kilku informacji.
            </Typography>
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="name"
              name="name"
              value={accordionCTX.form.name}
              disabled
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="surname"
              name="surname"
              value={accordionCTX.form.surname}
              disabled
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="pesel"
              name="pesel"
              value={accordionCTX.form.pesel}
              disabled
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="idNumber"
              label="Podaj serię i numer dowodu osobistego:"
              name="idNumber"
              autoComplete="idNumber"
              helperText={'Format: ABC123456'}
              onChange={handleIdNumberChange}
              autoFocus
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  value="checkbox"
                  name="checkbox"
                  onChange={handleHasCompany}
                  checked={accordionCTX.form.hasCompany}
                />
              }
              label="Posiadam numer NIP lub działalność gospodarczą:"
            />
          </Grid>
          {accordionCTX.form.hasCompany && (
            <>
              <Grid topMargin item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="companyName"
                  label="Podaj nazwę firmy:"
                  name="companyName"
                  onChange={handleCompanyNameChange}
                />
              </Grid>
              <Grid topMargin item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="nip"
                  label="Podaj NIP:"
                  name="nip"
                  onChange={handleNipChange}
                />
              </Grid>
              <Grid topMargin item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="regon"
                  label="Podaj REGON:"
                  name="regon"
                  onChange={handleRegonChange}
                />
              </Grid>
              <Grid topMargin item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      required
                      value="bigAgreementNIP"
                      name="bigAgreementNIP"
                      onChange={handleCheckboxChange}
                      checked={accordionCTX.form.bigAgreementNIP}
                    />
                  }
                  label={texts.accordionFormFinancialSectorCooperationInfo1}
                />
              </Grid>
            </>
          )}
          <Grid topMargin item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  value="bigAgreement"
                  name="bigAgreement"
                  onChange={handleCheckboxChange}
                  checked={accordionCTX.form.bigAgreement}
                />
              }
              label={texts.accordionFormFinancialSectorCooperationInfo2}
            />
          </Grid>
          <Grid topMargin container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              disabled={fourthStageButtonDisabled}
              onClick={async () => await submitFullForm()}
            >
              Sprawdź historię Twojej współpracy z sektorem finansowym!
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
